import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import RateUsStep from "./RateUsStep";
import "../../styles/MedicalHistory.css";

// Modal shell (reuses the Medical History modal look) around the Rate & Review form.
export default function RateReviewModal({ onClose }) {
  const stepRef = useRef(null);
  const [visitSelected, setVisitSelected] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await stepRef.current?.submit();
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="mh-root">
      <div
        className="mh-overlay mh-overlay--rate"
        role="dialog"
        aria-modal="true"
        aria-label="Rate & Review"
        onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      >
        {/* <div
  className="mh-modal mh-modal--rate"
  style={{ width: "min(560px, 100%)", maxWidth: "560px" }}
> */}
<div
  className="mh-modal mh-modal--rate"
  style={
    visitSelected
      ? undefined // form view: original CSS size (960 / 1080 / 1200px)
      : { width: "min(560px, 100%)", maxWidth: "560px" } // list view: compact
  }
>
          <div className="mh-header" style={{ padding: "8px 14px" }}>
            <div className="mh-header-left">
              <div className="mh-header-titles">
                <div className="mh-header-title">Rate &amp; Review</div>
              </div>
            </div>
            <button className="mh-close-btn" onClick={onClose} aria-label="Close">✕</button>
          </div>

          <div className="mh-body">
            <RateUsStep
              ref={stepRef}
              onApiSuccess={onClose}
              onVisitSelectedChange={setVisitSelected}
            />
          </div>

          {/* ── Footer: Close always, Submit once a visit is selected ── */}
          <div style={{ padding: "12px 20px", borderTop: "1px solid #e5ddd3", display: "flex", justifyContent: visitSelected ? "flex-end" : "center", gap: 10, flexShrink: 0, background: "var(--mh-card-bg)" }}>
            <button
              type="button"
              className="mh-footer-close"
              onClick={onClose}
              disabled={saving}
              style={{ padding: "9px 22px", fontSize: 13.5 }}
            >
              Close
            </button>
            {visitSelected && (
              <button
                type="button"
                onClick={handleSubmit}
                disabled={saving}
                style={{ background: "#2a9d8f", color: "#fff", border: "none", borderRadius: 8, padding: "9px 22px", fontWeight: 700, fontSize: 13.5, cursor: "pointer", opacity: saving ? 0.7 : 1 }}
              >
                {saving ? "Submitting…" : "Submit"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}